import { useState } from "react";

export default function Carousel({ slides, delay, visible }) {
    const [index, setIndex] = useState(0);

    const prev = () => {
        setIndex((i) => (i - 1 + slides.length) % slides.length);
    };

    const next = () => {
        setIndex((i) => (i + 1) % slides.length);
    };

    const current = slides[index];

    return (
        <div>
        <div
            className={`carousel ${visible ? "animate" : ""}`}
            style={{
                animationDelay: visible ? `${0.2 + delay}s` : "0s",
            }}
        >
            <img src={current.backgroundImage} alt={current.description} className="carousel-image" />
            <button onClick={prev} className="carousel-button carousel-button-left" aria-label="Previous slide">
                ‹
            </button>
            <button onClick={next} className="carousel-button carousel-button-right" aria-label="Next slide">
                ›
            </button>
        </div>
        {/* Moved title and description out from above given more easy to read */}
        <h3>{current.title}</h3>
        <div style={{fontSize:'large'}}>{current.description}</div>
        </div>
    );
}
